import styled from 'styled-components';
import { border1, gray } from '../../../../utils/style/colors';

export const NotificationBadges = styled('div')`
  & > * {
    margin: 0.8rem 0 0 0.5rem;
  }
`;

export const NotificationInputsContainer = styled('div')`
  flex: 0.5;
  margin-left: 1rem;
  overflow: scroll;
`;

export const NotificationBadgesContainer = styled('div')`
  flex: 0.3;
  display: flex;
  border-right: 1px solid #c8cee0;
  padding-right: 1rem;
  flex-direction: column;
  justify-content: center;
  & > *:first-child {
    & > span {
      margin-top: 0;
    }
  }
`;

export const AddNofiticationContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${gray};
  cursor: pointer;
  margin: 1rem 0;
`;

export const NotificationSettingsContainer = styled('div')`
  display: flex;
  @media screen and (max-width: 1165px) {
    flex-direction: column;
    & > * {
      flex-wrap: wrap;
      align-items: center;
      margin-left: 0 !important;
      border-right: 0 !important;
      padding-right: 0 !important;
      flex-direction: row !important;
      justify-content: space-between;
      :last-child {
        & > * {
          width: calc(100% / 2);
          @media screen and (max-width: 793px) {
            width: 100%;
          }
        }
        margin-top: 1rem;
      }
    }
  }
`;

export const SendSMSBaseOnQuestionContainer = styled.div`
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  border-radius: 1rem;
  border: ${border1};
  padding: 0.5rem;
`;
